/* eslint-disable max-len */
import { observer } from 'mobx-react';
import { Banner } from '../../components/Container/Banner';
import { useEffect, useState } from 'react';
import { useStore } from '../../core/utils/hook';
import { ACCOUNT_STATUS, MSG, SCREEN_MODE } from '../../core/configs/constants';
import Card from './Card';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { BuyCardsModal } from './Modal';
import { URL_SOCKET_CARD } from '../../core/utils/socket';
import { calculateCardInfo, roundDecimalNumber } from '../../core/utils/common';
import { io } from 'socket.io-client';

import classNames from 'classnames';
import './style.scss';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import yup from '../../core/utils/yupValidate';
import { flowResult } from 'mobx';
import { FormatNumber } from '../../components';
import SendMailMessage from './Modal/SendMailMessage';

export default observer(function ConfirmPurchaseCardsSreen(props) {
    //hook
    const [urlSearchParams] = useSearchParams()
    const rawCardIds = urlSearchParams.get('cardIds') || '';
    const navigate = useNavigate();

    if (!rawCardIds) {
        //
    }

    let cardIds = rawCardIds.split(',').map(id => Number(id));
    //store
    const { authStore: { accountInfo, getInfo, accountList },
        cardStore: { listCardInCart, getListAvailableCard, setAttrObservable, buyCard, clean },
        purchaseStore: { getCardsForConfirmPurchase, mapTokenExchangePurchase },
        userStore: { dropAddresses, getDropAddresses },
        modalStore: { hide, show } } = useStore();
    //state
    const validateSchemaPurchase = yup.object().shape({
        exchanges: yup.array().of(
            yup.object().shape({
                exchangeId: yup.number().required(),
                tokenCards: yup.array().of(
                    yup.object().shape({
                        cardIds: yup.array(yup.number()).min(1).required(MSG['error.required']),
                        dropAddress: yup.string().transform(value => (value == null ? undefined : value)).trim().required(MSG['error.required']),
                        tokenMappingId: yup.number().required(MSG['error.required'])
                    })
                ).min(1).required(MSG['error.required'])
            })
        ).min(1).required(MSG['error.required'])
    })
    const { register, handleSubmit, getValues, reset, formState: { errors, isSubmitting }, control, setValue, watch } = useForm({
        resolver: yupResolver(validateSchemaPurchase),
        mode: 'onChange',
        defaultValues: {
            exchanges: []
        }
    });

    const { fields, append, remove, update } = useFieldArray({
        control,
        name: 'exchanges'
    })
    const watchExchanges = watch('exchanges');

    const [mapEx, setMapEx] = useState(new Map());
    const [mapToken, setMapToken] = useState(new Map());
    const [mapDropAddress, setMapDropAddress] = useState(new Map());

    //life cycle   
    useEffect(() => {
        if (accountInfo?.status === ACCOUNT_STATUS.SUBSCRIBED.key) {
            getPurchaseConfirm();
        }
        //reset({ cardIds: [] });

        return () => {
            setAttrObservable('listCardInCart', [], false, true);
        }
    }, [accountInfo])

    useEffect(() => {
        if (mapToken.size > 0) {
            getDropAddressList();
        }
    }, [mapToken])

    //modal
    const openSendMailMessage = () => {
        show({
            id: 'modal-message',
            isOpen: true,
            notButtonX: true,
            children: (<SendMailMessage
                text={MSG['inform.success.buy_card']}
                cb={() => {
                    navigate('/purchase-card');
                    hide();
                }} />
            )
        })
    }
    //function
    const getPurchaseConfirm = async () => {
        const result = await flowResult(getCardsForConfirmPurchase({
            cardIds: [...cardIds]
        }));
        if (result) {
            let data = result.data;
            if (data?.length) {
                let dataForm = [];
                let exchangeMap = new Map();
                let tokenMappingMap = new Map();
                for (const ex of data) {
                    let { exchange, tokenCards = [] } = ex;
                    exchangeMap.set(exchange.id, exchange);
                    let init = {
                        exchangeId: exchange.id,
                        tokenCards: []
                    }
                    if (tokenCards?.length) {
                        let listCardOfToken = [];
                        for (const tokenCard of tokenCards) {
                            let { token, cardsOfToken } = tokenCard;
                            listCardOfToken.push({
                                cardIds: cardsOfToken.map(c => c.id),
                                dropAddress: null,
                                tokenMappingId: token.tokenMappingId
                            })
                            tokenMappingMap.set(token.tokenMappingId, tokenCard)
                        }

                        init.tokenCards = [...listCardOfToken];
                    }
                    dataForm.push(init);
                }

                setValue('exchanges', dataForm);
                setMapEx(exchangeMap);
                setMapToken(tokenMappingMap);
            }
        }
    }

    const getDropAddressList = async () => {
        const tokenIds = [...new Set(
            Array.from(mapToken.values())
                .map(item => item.token?.id)
                .filter(id => id != null)
        )];

        const data = await flowResult(getDropAddresses({
            tokenIds
        }));
        if (data && data?.length > 0) {
            let dropMap = new Map();
            for (const dropItem of data) {
                let { tokenId, exchangeId, dropAddress } = dropItem;
                let currentDropListOfToken = dropMap.get(`${exchangeId}-${tokenId}`) || [];
                currentDropListOfToken.push(dropAddress)
                dropMap.set(`${exchangeId}-${tokenId}`, currentDropListOfToken);
            }
            setMapDropAddress(dropMap);
        }

    }

    const onSubmit = async (data) => {
        let payload = {
            cardIds,
            carts: []
        }
        let exchanges = data.exchanges;
        for (const ex of exchanges) {
            payload.carts.push(...ex.tokenCards);
        }

        const submitResult = await flowResult(buyCard(payload));
        if (submitResult) {
            openSendMailMessage();
        }

    }


    return <div className='holder-screen confirm-purchase-screen'>
        <Banner />
        <div className='wrapper-form min-height-750'>
            <div className='w-100 text-center pd-tb-20'>
                <h1 className='fw-semi-bold'>購入情報確認</h1>
            </div>
            <form onSubmit={handleSubmit(onSubmit)} className='wrapper-form-detail'>
                {
                    fields?.length > 0 && fields.map((id, index) => {
                        let exchangeInfo = watchExchanges[index];

                        let { exchangeId, tokenCards = [] } = exchangeInfo;

                        let exchangeName = mapEx.get(exchangeId)?.name;

                        return <div key={id} className='wrapper-exchange border-bottom'>
                            <div className='fs-heading-large text-color-cs-9 fw-bold'>取引所: {exchangeName}</div>
                            <div className='wrapper-token'>
                                {
                                    tokenCards?.length > 0 && tokenCards.map((tc, idx) => {
                                        let { tokenMappingId } = tc;
                                        let tokenInfo = mapToken.get(tokenMappingId);
                                        let { token, cardsOfToken = [], totalPayment, totalAirdrop } = tokenInfo
                                        let totalCard = cardsOfToken.length;
                                        let listDropAddress = mapDropAddress.get(`${exchangeId}-${token?.id}`) || []

                                        return <div key={`token-${tokenMappingId}`} className='mg-t-15'>
                                            <div className='fs-heading-normal fw-bold text-color-cs-1'>{token?.name} ({token?.unit})</div>
                                            <div className='token-box mg-t-20 d-flex flex-column flex-gap-15 fs-label'>
                                                <div className='token-box-item'>
                                                    <label className='token-item-label font-medium text-color-cs-8 pd-none'>選択したカード数</label>
                                                    <div>{totalCard}</div>
                                                </div>
                                                <div className='token-box-item'>
                                                    <label className='token-item-label font-medium text-color-cs-8 pd-none'>Airdrop総量</label>
                                                    <div className=''>
                                                        <FormatNumber className='font-medium' statusDisplay='text' suffix={` ${token?.unit}`} value={totalAirdrop} />
                                                    </div>
                                                </div>
                                                <div className='token-box-item specific-box-input'>
                                                    <label className='token-item-label font-medium text-color-cs-8 pd-none'>受け取りID</label>
                                                    <div className='flex-grow-1 '>
                                                        <Controller
                                                            control={control}
                                                            name={`exchanges.${index}.tokenCards.${idx}.dropAddress`}
                                                            render={({ field }) => {

                                                                return <select
                                                                    {...field}
                                                                    value={field.value ?? ''}
                                                                    className="bg-black min-width-200 max-width-400 w-100 pd-5 height-40 text-color-cs-2"
                                                                    id="drop-address-id" >
                                                                    <option value="" disabled hidden />
                                                                    {listDropAddress && listDropAddress.length > 0 && listDropAddress.map((dropAdd) =>
                                                                        <option key={dropAdd} value={dropAdd}>{dropAdd}</option>)}
                                                                </select>
                                                            }}
                                                        />
                                                        {
                                                            errors?.exchanges && errors?.exchanges[index] && errors?.exchanges[index]?.tokenCards &&
                                                            errors?.exchanges[index]?.tokenCards[idx] &&
                                                            <div className='text-danger mg-t-5 fs-error'>
                                                                {errors?.exchanges[index]?.tokenCards[idx].dropAddress?.message}
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className='token-box-item'>
                                                    <label className='token-item-label font-medium text-color-cs-8 pd-none'>小計</label>
                                                    <div className='fs-heading-small'>
                                                        <FormatNumber className='text-danger fw-bold' statusDisplay='text' suffix=' 円' value={totalPayment} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                    })
                }
                <div className='mg-t-50 w-100 d-flex justify-content-center fs-heading-small'>
                    <div className='width-600 d-flex flex-column shadow flex-gap-24 border-radius-10 mw-100 pd-lr-32 pd-tb-24 bg-cs-box'>
                        <div className='d-flex justify-content-between align-items-center'>
                            <label className='font-medium'>合計カード数</label>
                            <span>{mapTokenExchangePurchase?.totalCard}</span>
                        </div>
                        <div className='d-flex justify-content-between align-items-center'>
                            <label className='font-medium'>合計トークン数</label>
                            <span>{mapTokenExchangePurchase?.totalToken}</span>
                        </div>
                        <div className='d-flex justify-content-between text-danger align-items-center'>
                            <label className='text-color-cs-red font-medium'>支払合計</label>
                            <FormatNumber className='text-color-cs-red fs-heading-normal fw-bold' statusDisplay='text' suffix=' 円' value={mapTokenExchangePurchase?.totalAllPayment} />
                        </div>
                    </div>
                </div>
                <div className='mg-t-60 pd-b-20'>
                    <div className='d-flex justify-content-center gap-lg-5 gap-md-4 gap-sm-3 gap-2'>
                        <button
                            type='button'
                            className='btn btn-cs-1 text-color-cs-white width-250 btn-common'
                            onClick={() => { navigate('/purchase-card') }}>キャンセル</button>
                        <button type='submit' className='btn btn-bg-cs-1 width-250 btn-common' disabled={isSubmitting}>決済
                        </button>
                    </div>
                </div>
                <div></div>
            </form>

        </div>
    </div>
});
